module.exports = __webpack_public_path__ + "static/media/social1Op.5335a343.png";